import { FC, useEffect, useState } from "react";

import { BlogersType, getAllBlogers } from "../../api/blogers";
import BigLoader from "../../components/common/BigLoader";
import InfoMessage from "../../components/InfoMessage";
import { infoMessageTypes } from "../../constants";
import { getCurrency } from "../../utils/getCurrency";

export const Blogers: FC = () => {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [blogersData, setBlogers] = useState<BlogersType | null>(null);

	useEffect(() => {
		const getBlogers = async () => {
			try {
				const data = await getAllBlogers();
				setBlogers(data);
			} catch (err) {
				if (err instanceof Error) {
					setError(err.message);
				}
			} finally {
				setLoading(false);
			}
		};

		getBlogers();
	}, []);

	return (
		<main className="blogers">
			{loading ? (
				<BigLoader />
			) : error ? (
				<InfoMessage type={infoMessageTypes.error} message={error} />
			) : blogersData && blogersData.partnersData.length ? (
				<>
					<div className="blogers__statistics">
						<p className="blogers__earned">
							Visits: <span className="blogers__earned--span">{blogersData.totalVisits}</span>
						</p>
						<div className="blogers__line" />
						<p className="blogers__earned">
							Purchases: <span className="blogers__earned--span">{blogersData.totalPurchases}</span>
						</p>
						<div className="blogers__line" />
						<p className="blogers__earned">
							Revenue: <span className="blogers__earned--span">{getCurrency(blogersData.totalRevenue)}</span>
						</p>
					</div>
					<table className="bloger__table">
						<thead>
							<tr className="bloger__tr">
								<th className="bloger__th">Name</th>
								<th className="bloger__th">Visits</th>
								<th className="bloger__th">Purchases</th>
								<th className="bloger__th">Revenue</th>
							</tr>
						</thead>
						<tbody className="bloger__tbody">
							{blogersData.partnersData.map((item) => (
								<tr className="bloger__tr" key={item.id}>
									<td className="bloger__td">
										<div className="bloger__wrapper">
											<div className="bloger__picture">
												<img
													className="bloger__img"
													src={item.imageLink}
													alt=""
													aria-hidden
													width={30}
													height={30}
												/>
											</div>
											<p className="bloger__name">{item.name}</p>
										</div>
									</td>
									<td className="bloger__td">{item.referralClicksCount}</td>
									<td className="bloger__td">{item.referralsCount}</td>
									<td className="bloger__td">{getCurrency(item.referralsSum)}</td>
								</tr>
							))}
						</tbody>
					</table>
				</>
			) : (
				<p>There are no blogers</p>
			)}
		</main>
	);
};
